import { Component, OnInit } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { AuthService } from '@shared/services/auth.service';
import { ResidentSearchDialogComponent } from './resident-search-dialog/resident-search-dialog.component';

@Component({
  selector: 'aaos-roster-page',
  templateUrl: './roster-page.component.html',
  styleUrls: ['./roster-page.component.scss']
})
export class RosterPageComponent implements OnInit {

  editPrivileges = false;
  constructor(private dialog: MatDialog,
              private authService: AuthService) { }

  ngOnInit() {
    this.editPrivileges = this.authService.changeAuthorized();
  }

  openSearchDialog() {
    const dialogRef = this.dialog.open(ResidentSearchDialogComponent, this.getModalConfig());

  }

  getModalConfig() {
    return {
      panelClass: 'wide-dialog',
      disableClose: true,
      autoFocus: false,
      data: null,
    } as MatDialogConfig;
  }

}
